import React from 'react';

import {
  ORGANIZATION_PENDING_INVITATIONS_LIST_QUERY_KEY,
  PendingInvitationsListPage,
} from '../../shared/users';

export const PendingInvitationsList: React.FC = () => (
  <PendingInvitationsListPage
    queryKeyBase={ORGANIZATION_PENDING_INVITATIONS_LIST_QUERY_KEY}
    displayTypePrefKey="OrganizationPendingInvitations"
    usersRoute="/app/organization/users"
    linkContext="organization"
  />
);
